import { QuestionTypeEnum } from './question-type-enum'
import { SecuredReflection } from './secured-reflection'

export interface AnswerStatsInterface {
  handoutId: number
  outlineId: number
  questionId: number
  questionType?: QuestionTypeEnum
  /**
   * 已做答人数
   */
  answered?: number
  /**
   * 未做答人数
   */
  noAnswered?: number
  /**
   * 正确率
   */
  correctRate?: number
  /**
   * 选项统计情况，针对选择题（如: {'A': 1, 'B': 2}）
   */
  optionsStats?: object
  /**
   * 已做答人数用户id
   */
  answeredRids?: number[]
  /**
   * 未做答人数用户id
   */
  noAnsweredRids?: number[]
  /**
   * 选项统计情况用户id
   */
  optionsStatsRids?: object
  reflections?: SecuredReflection[]
}

export class AnswerStats implements AnswerStatsInterface {
  handoutId: number
  outlineId: number
  questionId: number
  questionType?: QuestionTypeEnum
  /**
   * 已做答人数
   */
  answered?: number
  /**
   * 未做答人数
   */
  noAnswered?: number
  /**
   * 正确率
   */
  correctRate?: number
  /**
   * 选项统计情况，针对选择题（如: {'A': 1, 'B': 2}）
   */
  optionsStats?: object
  /**
   * 已做答人数用户id
   */
  answeredRids?: number[]
  /**
   * 未做答人数用户id
   */
  noAnsweredRids?: number[]
  /**
   * 选项统计情况用户id
   */
  optionsStatsRids?: object
  reflections?: SecuredReflection[]

  constructor(props: AnswerStatsInterface) {
    const {
      // 重命名变量以规避与 JS 保留词的冲突, 比如 default, with
      handoutId: _handoutId,
      outlineId: _outlineId,
      questionId: _questionId,
      questionType: _questionType,
      answered: _answered,
      noAnswered: _noAnswered,
      correctRate: _correctRate,
      optionsStats: _optionsStats,
      answeredRids: _answeredRids,
      noAnsweredRids: _noAnsweredRids,
      optionsStatsRids: _optionsStatsRids,
      reflections: _reflections,
      // 可能会有额外字段比如自定义字段不在类型定义中
      ...rest
    } = props

    Object.assign(this, rest)

    this.handoutId = _handoutId
    this.outlineId = _outlineId
    this.questionId = _questionId
    this.questionType = _questionType
    this.answered = _answered
    this.noAnswered = _noAnswered
    this.correctRate = _correctRate
    this.optionsStats = _optionsStats
    this.answeredRids = _answeredRids
    this.noAnsweredRids = _noAnsweredRids
    this.optionsStatsRids = _optionsStatsRids
    this.reflections = _reflections
      ? _reflections.map((i) => new SecuredReflection(i))
      : _reflections
  }
}
